exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.uk-float-right .uk-button {\n  font-size: 15px; }\n\n.new-faq .uk-button {\n  font-size: 15px; }\n\n.new-faq .tag-error, .new-faq #body {\n  font-size: 14px;\n  margin-top: 15px;\n  color: red; }\n\n.new-faq .custom-tag-input .selected-tags .uk-label {\n  position: relative; }\n  .new-faq .custom-tag-input .selected-tags .uk-label span {\n    cursor: pointer; }\n    .new-faq .custom-tag-input .selected-tags .uk-label span:hover {\n      opacity: 0.8; }\n\n.new-faq .custom-tag-input .tag-dropdown .tag-option {\n  transition: background-color 0.2s ease; }\n  .new-faq .custom-tag-input .tag-dropdown .tag-option:hover {\n    background-color: #f5f5f5 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/faqs/new-faq/new-faq.component.scss
// module id = ../../../../../src-admin/app/components/faqs/new-faq/new-faq.component.scss
// module chunks = main